<template>
    <div class="user-config" v-loading="loading">
        <!-- <div class="config-item">
            <el-switch v-model="userInfo.isManualApprove" inactive-text="加我为好友时需要验证" @change="onManualApproveChange"></el-switch>
        </div> -->
        
        <div class="config-item">
            <el-switch v-model="notificationEnabled" inactive-text="启用桌面通知" @change="onNotificationChange"></el-switch>
            <div class="config-desc">当收到新消息时在桌面显示通知</div>
        </div>

        <div class="config-item">
            <div class="config-title">回车发送模式</div>
            <el-radio-group v-model="sendMode" @change="onSendModeChange">
                <el-radio label="enter_send">Enter 发送，Ctrl/Cmd + Enter 换行</el-radio>
                <el-radio label="mod_enter_send">Ctrl/Cmd + Enter 发送，Enter 换行</el-radio>
            </el-radio-group>
        </div>
        
        <div class="config-item">
            <el-button type="primary" size="mini" @click="requestNotificationPermission">请求通知权限</el-button>
            <div class="config-desc">如果桌面通知不工作，请点击此按钮重新请求权限</div>
        </div>
        <div class="clear-cache" title="如果消息显示异常，可以尝试初始化数据">
            数据初始化&nbsp;&nbsp;<el-button type="primary" size="mini" @click="clearCache">确认</el-button>
            <div class="config-desc">如果消息显示异常，可以尝试初始化数据</div>
        </div>
        <div class="config-item">
            <el-button type="primary" size="mini" @click="requestCameraPermission">请求视频权限</el-button>
            <el-button type="primary" size="mini" @click="requestMicrophonePermission" style="margin-left: 10px;">请求语音权限</el-button>
            <div class="config-desc">
                如果您首次拒绝了摄像头/麦克风权限，可以点击上方按钮重新请求。<br>
                如浏览器未弹出权限框，请在浏览器地址栏手动开启权限。
            </div>
        </div>
        <!-- <div class="config-item">
            <el-button type="info" size="mini" @click="showPageStatus">查看页面状态</el-button>
            <div class="config-desc">查看当前页面状态，帮助调试通知显示逻辑</div>
        </div> -->
    </div>
</template>
<script>
import { getUserKey } from '@/utils/common.js';
import notificationManager from '@/utils/notification.js';

export default {
    name: "userConfig",
    data() {
        return {
            userInfo: {
                isManualApprove: false
            },
            notificationEnabled: false,
            sendMode: 'enter_send',
            loading: false,
        }
    },
    methods: {
        init() {
            let mine = this.$store.state.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
            
            // 初始化通知设置
            this.notificationEnabled = localStorage.getItem(getUserKey('notificationEnabled', this.mine.id)) !== 'false';
            this.sendMode = localStorage.getItem(getUserKey('sendMode', this.mine.id)) || 'enter_send';
        },
        onManualApproveChange() {
            this.$http({
                url: "/user/manualApprove?enabled=" + this.userInfo.isManualApprove,
                method: 'put'
            }).then(() => {
                this.$store.dispatch("loadUser");
                this.$message.success(`您${this.userInfo.isManualApprove ? '开启' : '关闭'}了好友审核验证`);
            })
        },
        onNotificationChange() {
            localStorage.setItem(getUserKey('notificationEnabled', this.mine.id), this.notificationEnabled);
            this.$message.success(`桌面通知已${this.notificationEnabled ? '启用' : '禁用'}`);
        },
        onSendModeChange() {
            localStorage.setItem(getUserKey('sendMode', this.mine.id), this.sendMode);
            this.$eventBus && this.$eventBus.$emit('chat:send-mode-change', this.sendMode);
            this.$message.success('发送模式已更新');
        },
        async requestNotificationPermission() {
            try {
                const hasPermission = await notificationManager.requestPermission();
                if (hasPermission) {
                    this.$message.success('通知权限已获取');
                    this.notificationEnabled = true;
                    localStorage.setItem(getUserKey('notificationEnabled', this.mine.id), 'true');
                } else {
                    this.$message.warning('通知权限被拒绝，请在浏览器设置中手动开启');
                }
            } catch (error) {
                this.$message.error('请求通知权限失败');
                console.error('请求通知权限失败:', error);
            }
        },
        async requestCameraPermission() {
            try {
                await navigator.mediaDevices.getUserMedia({ video: true });
                this.$message.success('摄像头权限已获取');
            } catch (e) {
                if (e && e.name === 'NotAllowedError') {
                    this.$message.warning('摄像头权限被拒绝，请在浏览器设置中手动开启');
                } else {
                    this.$message.error('请求摄像头权限失败');
                }
            }
        },
        async requestMicrophonePermission() {
            try {
                await navigator.mediaDevices.getUserMedia({ audio: true });
                this.$message.success('麦克风权限已获取');
            } catch (e) {
                if (e && e.name === 'NotAllowedError') {
                    this.$message.warning('麦克风权限被拒绝，请在浏览器设置中手动开启');
                } else {
                    this.$message.error('请求麦克风权限失败');
                }
            }
        },
        showPageStatus() {
            const status = notificationManager.getPageStatus();
            this.$alert(`
页面状态信息：\n
- 可见性状态: ${status.visibilityState}\n
- 窗口尺寸: ${status.windowSize.width} x ${status.windowSize.height}
- 是否有焦点: ${status.hasFocus ? '是' : '否'}
- 页面是否活动: ${status.isActive ? '是' : '否'}
- 是否显示通知: ${status.isActive ? '否' : '是'}

说明：
- 页面活动 = 页面可见 + 窗口未最小化 + 有焦点
- 只有在页面非活动状态时才会显示桌面通知
            `, '页面状态', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true
            });
        },
        clearCache() {
            this.$confirm('确定要初始化所有聊天记录？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.$message.success(`正在初始化...`);
                this.$store.commit("removeAllChat")
            })
        }
    },
    computed: {
        mine() {
            return this.$store.state.userStore.userInfo;
        }
    }
}
</script>
<style scoped lang="scss">
.user-config {
    padding: 20px;
}

.config-item {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #fafafa;
}

.config-desc {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
    line-height: 1.4;
}

.config-title {
    font-size: 14px;
    color: #303133;
    margin-bottom: 10px;
    font-weight: 600;
}

.clear-cache {
    font-size: 15px;
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #fafafa;
}
</style>
